import { showNotification } from './notificationHelper'

// This is tightly coupled with the back-end. The back-end sets a flash message using the helper
// method `flash_message` in `app/helpers/application_helper.rb`. We then call render_flash and that
// adds these messages to window.flashMessages. We then iterate over those messages and display them.

// window.sessionStorage.flashMessage is used in one place right now. After a caregiver is added we
// redirect to the compliance report (main dashboard) and display a message.

interface FlashMessage {
	message: string
	type: 'alert' | 'error' | 'notice'
}

declare global {
	interface Window {
		flashMessages: FlashMessage[]
	}
}

function messageFromSessionStorage(): void {
	const message = attemptSessionAccess()

	if (message) {
		window.sessionStorage.removeItem('flashMessage')
		window.flashMessages.push({ message, type: 'notice' })
	}
}

function attemptSessionAccess(): string | null {
	let message: string | null = null

	try {
		message = window.sessionStorage.flashMessage
	} catch (error) {
		if ((error as Error).name === 'SecurityError') {
			// Cookies are likely disabled. Ignore this error.
		} else {
			// Re-throw the error if it's not a SecurityError
			throw error
		}
	}

	return message
}

export default function initFlashMessages(): void {
	window.flashMessages = window.flashMessages || []

	messageFromSessionStorage()

	window.flashMessages.forEach(message => {
		if (message.type === 'notice') {
			showNotification(message.message, 'success')
		} else {
			showNotification(message.message, 'error')
		}
	})
}
